module.exports = __webpack_public_path__ + "img/goldLogo.1ac87fb4.svg";